"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.PickupPointSelection = void 0;
var _mui = require("@ori-ui/mui");
var _SearchConfigurationProvider = require("../../containers/SearchConfigurationProvider");
var _contexts = require("../../contexts");
var _hooks = require("../../hooks");
var _models = require("../../models");
var _AddNewDeliveryButton = require("../AddNewDeliveryButton");
var _SelectPickupPointDialog = require("../SelectPickupPointDialog");
var _SelectableAddress = require("../addresses/SelectableAddress");
var _shared = require("../shared");
var _jsxRuntime = require("react/jsx-runtime");
// TODO: Reduce props: isFindPickupPointsOpen!
/**
 * Displays current state of pick-up point delivery selection for flat selection UI.
 *
 * Always displays a button for opening pickup points dialog (merged map + pickup points list).
 * When a pick-up point is selected, displays small variant of the button. If no selection,
 * displays large variant with label & add icon.
 *
 * Displays details of selected pickup point (if available) in a form of SelectableCard component.
 */
const PickupPointSelection = ({
  isDeliveryOptionsLoaded,
  isFindPickupPointsOpen,
  isLoading,
  onDeliveryItemActivation,
  onShippingOfferBannerClick,
  selectedItemPickup,
  togglePickupPointsDialog
}) => {
  const {
    formatMessage
  } = (0, _hooks.useTranslations)();
  if (isLoading && !selectedItemPickup) {
    return null;
  }
  const isSelection = selectedItemPickup !== null;
  return /*#__PURE__*/(0, _jsxRuntime.jsxs)(_shared.FlatLayoutWrapper, {
    children: [/*#__PURE__*/(0, _jsxRuntime.jsx)(_mui.Typography, {
      variant: "h6",
      children: formatMessage('pickupPoint')
    }), /*#__PURE__*/(0, _jsxRuntime.jsx)(_AddNewDeliveryButton.AddNewDeliveryButton, {
      label: formatMessage(isSelection ? 'edit' : 'addPickupPoint'),
      testId: _models.TestId.SelectPickupPointButton,
      variant: isSelection ? 'small' : 'large',
      onClick: togglePickupPointsDialog
    }), isSelection ? /*#__PURE__*/(0, _jsxRuntime.jsx)(_SelectableAddress.SelectableAddress, {
      isActive: true,
      boxName: "Pick-up point",
      deliveryItem: selectedItemPickup,
      isDisabled: isLoading,
      metaHierarchy: [],
      onShippingOfferBannerClick: onShippingOfferBannerClick
    }) : null, isDeliveryOptionsLoaded && isFindPickupPointsOpen ? /*#__PURE__*/(0, _jsxRuntime.jsx)(_SearchConfigurationProvider.SearchConfigurationProvider, {
      showFullScreenLoader: true,
      children: /*#__PURE__*/(0, _jsxRuntime.jsx)(_contexts.PickupPointsProvider, {
        enabled: isFindPickupPointsOpen,
        children: /*#__PURE__*/(0, _jsxRuntime.jsx)(_contexts.MapProvider, {
          deliveryChannelId: selectedItemPickup?.deliveryChannelId,
          togglePickupPointsDialog: togglePickupPointsDialog,
          onDeliveryItemActivation: onDeliveryItemActivation,
          children: /*#__PURE__*/(0, _jsxRuntime.jsx)(_SelectPickupPointDialog.SelectPickupPointDialog, {
            open: isFindPickupPointsOpen
          })
        })
      })
    }) : null]
  });
};
exports.PickupPointSelection = PickupPointSelection;